import React from 'react';
import Kanban from './Kanban';
export default function Prospects() {
  return <Kanban type="prospect" title="Prospects" />;
}
